module.exports = __webpack_public_path__ + "assets/img/关于我们banner.a0b30fb6.jpg";